import { Pagination } from './commonTypes';

export enum SparePartsCondition {
  NEW = 'NEW',
  USED = 'USED',
}


export enum SparePartsStockStatus {
  IN_STOCK = 'IN_STOCK',
  LOW_STOCK = 'LOW_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}

export interface ScooterType {
  _id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface SparePartType {
  _id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateSparePartTypeBody {
  name: string;
}

export interface UpdateSparePartTypeBody {
  name: string;
}

export interface SparePart {
  _id: string;
  id: number;
  name: string;
  code?: string;
  photo?: string;
  scooterTypes?: ScooterType[];
  sparePartType?: SparePartType | string;
  supplier?: string;
  condition: SparePartsCondition;
  price: number;
  stockThresholdLow?: number;
  lastSupply?: string;
  stock?: Record<string, { available: number }>;
  stockCurrentCity?: { available: number; inDelivery?: number };
  stockInWarehouse?: Record<string, { available: number; name?: string }>;
  status?: SparePartsStockStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSparePartBody {
  name: string;
  code?: string;
  photo?: string;
  scooterTypes?: string[];
  sparePartType?: string;
  stockInWarehouse?: number;
  stockWarehouse?: string;
  supplier?: string;
  condition: SparePartsCondition;
  price: number;
  stockThresholdLow?: number;
  lastSupply?: string;
}

export interface UpdateSparePartBody extends Partial<CreateSparePartBody> {}

export interface UpdateSparePartStockBody {
  setAvailable?: number;
  stockWarehouse?: string;
  lastSupply?: string;
}

export interface GetSparePartsParams {
  name?: string;
  code?: string;
  scooterTypes?: string;
  sparePartType?: string;
  status?: SparePartsStockStatus;
  condition?: SparePartsCondition;
  page?: number;
  limit?: number;
}

export interface GetSparePartsResponse {
  data: SparePart[];
  pagination: Pagination;
}

export interface SparePartHistoryItem {
  _id: string;
  type: string;
  adminLogin: string;
  text: string;
  createdAt: string;
}

export interface GetSparePartHistoryParams {
  id: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface GetSparePartHistoryResponse {
  data: SparePartHistoryItem[];
  pagination: Pagination;
}

export interface CreateScooterTypeBody {
  name: string;
}

export interface UpdateScooterTypeBody {
  name: string;
}

export interface GetScooterTypesResponse {
  data: ScooterType[];
}

export enum SparePartOrderStatus {
  IN_DELIVERY = 'IN_DELIVERY',
  DELIVERED = 'DELIVERED',
  CANCELED = 'CANCELED'
}

export interface SparePartOrderItem {
  sparePart: string | SparePart;
  quantity: number;
}

export interface SparePartOrder {
  _id: string;
  name: string;
  description?: string;
  trackingNumber?: string;
  expectedDeliveryDate?: string;
  factDeliveryDate?: string;
  spareParts: SparePartOrderItem[];
  status: SparePartOrderStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSparePartOrderBody {
  name: string;
  description?: string;
  trackingNumber?: string;
  expectedDeliveryDate?: string;
  spareParts: { sparePart: string; quantity: number }[];
  status: 'IN_DELIVERY';
}

export interface UpdateSparePartOrderBody {
  status: 'DELIVERED' | 'CANCELED';
  factDeliveryDate?: string;
}

export interface GetSparePartOrdersParams {
  status?: SparePartOrderStatus;
  limit?: number;
  page?: number;
}

export interface GetSparePartOrdersResponse {
  data: SparePartOrder[];
  pagination: Pagination;
}
